import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "lp-wave-content" }
const _hoisted_2 = { class: "lp-wave-login ly-row ly-center-center" }
const _hoisted_3 = { class: "forgot-password-container card lp-load-fadein" }
const _hoisted_4 = {
  key: 2,
  class: "msg msg-error w-100 text-center"
}

import { ref, inject, Ref } from 'vue'
import NewForgotPasswordForm from './components/NewForgotPasswordForm.vue'
import ForgotPasswordRequested from './components/ForgotPasswordRequested.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewForgotPasswordView',
  setup(__props) {

const errorMessage: Ref<string> = ref('')
const showForgotPasswordForm: Ref<boolean> = ref(true)
const submitting: Ref<boolean> = ref(false)
let username

const forgotPassword = inject('forgotPassword') as (username: string, provider: string) => Promise<void>
const onForgotPasswordFormSubmitted = async (params: { email: string, provider: string }) => {
  if (submitting.value) return
  submitting.value = true
  errorMessage.value = ''
  try {
    await forgotPassword(params.email, params.provider)
    username = params.email
    showForgotPasswordForm.value = false
  } catch (error: any) {
    displayError({ message: 'Error trying to reset your password. Try again later' })
    console.log(error)
    submitting.value = false
  }
  submitting.value = false
}

const displayError = (error: any) => {
  error.message
    ? errorMessage.value = error.message
    : errorMessage.value = 'Unexpected Error'
}

return (_ctx: any,_cache: any) => {
  const _directive_load_fade_in = _resolveDirective("load-fade-in")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              (showForgotPasswordForm.value)
                ? (_openBlock(), _createBlock(NewForgotPasswordForm, {
                    key: 0,
                    onFormSubmitted: onForgotPasswordFormSubmitted,
                    isSubmitting: submitting.value
                  }, null, 8, ["isSubmitting"]))
                : (_openBlock(), _createBlock(ForgotPasswordRequested, { key: 1 })),
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, true]
          ])
        ]),
        _: 1
      })
    ])), [
      [_directive_load_fade_in, { delay: 1000, timeBetween: 500 }]
    ])
  ]))
}
}

})